import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import { observer } from 'mobx-react-lite'
import { teacher } from '../store/teacherRep.ts'
import ApplicationsExpect from './../block/applicationsTeacher/ApplicationsExpect'
import ApplicaionsDone from './../block/applicationsTeacher/ApplicationsDone'
import { reportTeacher } from './../store/reportTeacher'
import CheckBox from '../Components/CheckBox/CheckBox'
import http from './../Service/http'
import { direction } from '../store/direction'
import EmbassiesModal from '../Components/Modal/EmbassiesModal'
import { auth } from '../store/auth'
import { toast } from 'react-toastify'
import ReactPaginate from 'react-paginate'
import '../Styles/pagination.css'
import TeacherWorkModal from '../Components/Modal/TeacherWorkDocModal'


export const ApplicationTeachContainer = observer(function () {
	const [form, setForm] = useState(false)
	
	const { t, i18n } = useTranslation()
	const [isIspol, setIsIspol] = useState(false)
	const [currentPage, setCurrentPage] = useState(0);

	// console.log("AUTH",auth)
    const ITEMS_PER_PAGE = 25;
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const pageCount = Math.ceil(reportTeacher.reportExpected.length / ITEMS_PER_PAGE);

    const paginatedDisciplines = reportTeacher.reportExpected.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);

	const getReportsTeacher = async () => {
		const a = await http.post('/report/reportApplicationTeacher?reportType=' + null)
		reportTeacher.newReportTeacher(a.data.reportApplicationTeacherWait)
	}


	useEffect(() => {
		getReportsTeacher(0)
	}, [])

	const openForm = () => {
		setForm(!form)
	}

	const ispolnitelUpdate = async () => {
		const res = await http.post('/okno/ispolnitelStatusTeach', {
			id_zakaz: teacher.teacher.id_okno_zakaz,
			AVN_operator: auth.user.data.id,
			doc: teacher.teacher.id_okno_document
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			getReportsTeacher()
			setIsIspol(false)
		}
	}
	useEffect(() => {
		if (isIspol) {
			ispolnitelUpdate()
		}
	}, [isIspol])

	return (
		<CenterContent>
			<InstrumentsWrrapper
				leftHead={t('st:instrument.titles.appsExpected')}
				rightHead={t('st:instrument.titles.doneApps')}
				leftChilds={<ApplicationsExpect />}
				rightChilds={<ApplicaionsDone />}
			/>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№sss</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.executor')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.jobTitle')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.doc')}</th>
							<th style={{ width: '10%', textAlign: 'center' }}>{t('st:appTitle.titles.number')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.type')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.dateApp')}</th>
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.status')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.esp')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
						</tr>
					</thead>
					<tbody>
						{paginatedDisciplines.map((item, index) => {
							return (
								<tr
									onClick={() => {
										teacher.newTeacher(item)
									}}
								>
									<td>{index + 1 + currentPage * ITEMS_PER_PAGE}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									{item.status_new === false ? (
										<td onClick={() => setIsIspol(true)} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.ispolnitel}
										</td>
									) : (
										<td>{item.ispolnitel}</td>
									)}
									<td>{item.post}</td>
									{item.status_new === true ? (
										<td onClick={openForm} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.okno_document}
										</td>
									) : (
										<td>{item.okno_document}</td>
									)}
									<td>{item.reference_number}</td>

									<td>{item.status_online_offline}</td>
									<td>{item.date_insert}</td>

									{direction.leftOrRight == 'left' ? (
										<td>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
														})
														if (res.data.result === 'Заявка выполнено') {
															getReportsTeacher(reportTeacher.currentType)
														}
													}}
													checked={item.status === true ? true :false }
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{  display: 'inline-block', verticalAlign: 'middle', width: '17px'  }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
											style={{
											textAlign:'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}

									{direction.leftOrRight == 'left' ? (
										<td>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationEdsUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
															EDS: 1
														})
														if (res.data.result === 'Заявка отправлено на подпись') {
															getReportsTeacher(reportTeacher.currentType)
														}
													}}
													checked={item.EDS}
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{  display: 'inline-block', verticalAlign: 'middle', width: '17px'  }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
												style={{
											textAlign:'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}
								</tr>
							)
						})}
					</tbody>
				</table>
				{pageCount > 1 && (
                    <ReactPaginate
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                    />
                )}
				{teacher.teacher.id_okno_document === 20 ? form && <TeacherWorkModal openForm={openForm} /> : null}
			
			</div>
		</CenterContent>
	)
})
